import apiService from './api';
import {
  CustomerReportResponse,
  GSTReportResponse,
  ReceivedAmountReportResponse,
  GSTCustomerListResponse,
  ReportFilters,
  CustomerReportData,
  GSTReportData,
  BalanceReportDetail,
  BalanceReportDetailResponse,
  GSTCustomerData,
  InvoiceEmptyReportData,
  InvoiceEmptyDetailedReportData,
  EmptyStockTrackingReportData,
  ProductStockTrackingReportData,
} from '../types/reportTypes';

class ReportService {
  async getCustomerReport(filters: ReportFilters): Promise<CustomerReportData> {
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.customerId) params.append('customerId', filters.customerId);

    const response = await apiService.get<CustomerReportData>(
      `/reports/customers?${params.toString()}`
    );
    return response.data;
  }

  async getGSTReport(filters: ReportFilters): Promise<GSTReportData> {
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);

    const response = await apiService.get<GSTReportData>(
      `/reports/gst?${params.toString()}`
    );
    return response.data;
  }

  async getReceivedAmountReport(filters: ReportFilters): Promise<ReceivedAmountReportResponse> {
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.customerId) params.append('customerId', filters.customerId);

    const response = await apiService.get<ReceivedAmountReportResponse>(
      `/reports/received-amounts?${params.toString()}`
    );
    return response.data;
  }

  async getGSTCustomerList(filters: ReportFilters): Promise<GSTCustomerData> {
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.customerId) params.append('customerId', filters.customerId);

    const response = await apiService.get<GSTCustomerData>(
      `/reports/gst-customer-list?${params.toString()}`
    );
    return response.data;
  }

  async getBalanceReportDetail(
    customerId: string,
    filters?: { startDate?: string; endDate?: string }
  ): Promise<BalanceReportDetail> {
    const response = await apiService.post<BalanceReportDetail>(
      `/reports/customer-balance`,
      {
        customerId,
        startDate: filters?.startDate,
        endDate: filters?.endDate
      }
    );
    return response.data;
  }

  // ==================== INVOICE EMPTY REPORT ====================
  
  async getInvoiceEmptyReport(filters: ReportFilters): Promise<InvoiceEmptyReportData> {
    const params = new URLSearchParams();
    // if (filters.startDate) params.append('startDate', filters.startDate);
    // if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.customerId) params.append('customerId', filters.customerId);

    const response = await apiService.get<InvoiceEmptyReportData>(
      `/reports/invoice-empty?${params.toString()}`
    );
    return response.data;
  }

  async getInvoiceEmptyDetailedReport(filters: ReportFilters): Promise<InvoiceEmptyDetailedReportData> {
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.customerId) params.append('customerId', filters.customerId);

    const response = await apiService.get<InvoiceEmptyDetailedReportData>(
      `/reports/invoice-empty-detailed?${params.toString()}`
    );
    return response.data;
  }

  // ==================== EMPTY STOCK TRACKING REPORT ====================

  async getEmptyStockTrackingReport(filters: ReportFilters): Promise<EmptyStockTrackingReportData> {
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.customerId) params.append('customerId', filters.customerId);

    const response = await apiService.get<EmptyStockTrackingReportData>(
      `/reports/empty-stock-tracking?${params.toString()}`
    );
    return response.data;
  }

  // ==================== PRODUCT STOCK TRACKING REPORT ====================

  async getProductStockTrackingReport(filters: ReportFilters): Promise<ProductStockTrackingReportData> {
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.productId) params.append('productId', filters.productId);

    const response = await apiService.get<ProductStockTrackingReportData>(
      `/reports/product-stock-tracking?${params.toString()}`
    );
    return response.data;
  }
}

export const reportService = new ReportService();
export default reportService;